import styled from "styled-components";
import {WheelOfJackpotbetLogoDefaultBox} from "./wheel-of-jb-logo.default.box";

export const WheelOfJbLogoMrgreenBox = styled(WheelOfJackpotbetLogoDefaultBox)`
  width: 140px;
  height: 91.8px;
  margin-left: 0px;
`;